/*
 * Jira Ticket:
 * Created Date: Thu, 12th Mar 2020, 16:34:19 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { Button } from 'react-admin';

const ActionButton = ({
  name,
  disabled,
  icon,
  style,
  onClick,
  addLabel,
  basePath,
  variant = 'contained',
  ...rest
}) => {
  return (
    <Button
      label={name}
      disabled={disabled}
      variant={variant}
      onClick={onClick}
      {...rest}
    >
      {icon}
    </Button>
  );
};

ActionButton.defaultProps = { addLabel: false };

export default ActionButton;
